import { render, staticRenderFns } from "./varieties-echarts.vue?vue&type=template&id=8d039a2a&scoped=true&"
import script from "./varieties-echarts.vue?vue&type=script&lang=js&"
export * from "./varieties-echarts.vue?vue&type=script&lang=js&"
import style0 from "./varieties-echarts.vue?vue&type=style&index=0&id=8d039a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d039a2a",
  null
  
)

export default component.exports